import { TYPES } from "./draft_dialog.type";

const initState = {
  draftDialogAll: null,
  draftDialogOpenAdd: false,
  draftDialogOpenEdit: false,
  draftDialogSelected: null,
  draftDialogSearch: "",
  //
  draftDialogDetail: null,
  //
  draftDialogOpenDeny: false,
  draftDialogOpenWarn: false,
  draftDialogOpenForward: false,
  draftDialogAudioUrl: null,
  //
  draftDialogPlay: false,
  draftDialogSecond: 0,
  draftDialogKick: null,
};

const draftDialogReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DRAFT_DIALOG_KICK:
      return {
        ...state,
        draftDialogKick: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SECOND:
      return {
        ...state,
        draftDialogSecond: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_PLAY:
      return {
        ...state,
        draftDialogPlay: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_AUDIO_URL:
      return {
        ...state,
        draftDialogAudioUrl: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_DENY:
      return {
        ...state,
        draftDialogOpenDeny: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_WARN:
      return {
        ...state,
        draftDialogOpenWarn: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_FORWARD:
      return {
        ...state,
        draftDialogOpenForward: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_DETAIL:
      return {
        ...state,
        draftDialogDetail: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ALL:
      return {
        ...state,
        draftDialogAll: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_ADD:
      return {
        ...state,
        draftDialogOpenAdd: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_EDIT:
      return {
        ...state,
        draftDialogOpenEdit: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SELECTED:
      return {
        ...state,
        draftDialogSelected: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SEARCH:
      return {
        ...state,
        draftDialogSearch: payload,
      };

    default:
      return state;
  }
};

export default draftDialogReducer;
